export const EMAIL_FIELD = 'email'

export const getDefaultValues = () => ({
  [EMAIL_FIELD]: '',
})
